
<template>
  <v-container>
    <h2>Disposiciones aplicables a la función notarial</h2>
    <v-expansion-panels class="mt-2">
      <v-expansion-panel v-for="(ley,i) in leyes" :key="i">
        <v-expansion-panel-header>
          <template v-slot:default="{ open }">
            <v-fade-transition leave-absolute>
              <h3 style="text-align:center" v-if="open" key="0">{{ley.title}}</h3>
              <span  v-else key="1">{{ley.title}}</span>
            </v-fade-transition>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <component :is="ley.componentName" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import * as components from "./leyes";

export default {
  components, //: {...components},
  data: () => ({
    leyes: [
      {
        title: "Ley del Impuesto Sobre la Renta",
        componentName: "LISR"
      },
      {
        title: "Reglamento de la Ley del Impuesto Sobre la Renta",
        componentName: "RLISR"
      },
      {
        title: "Codigo Municipal de Chihuahua",
        componentName: "traslacion-dominio"
      },
      {
        title:
          "Ley de Ingresos del Municipio de Chihuahua Para el Ejercicio Fiscal de 2020",
        componentName: "LIM"
      },
      // {
      //   title: "Código Fiscal del Estado de Chihuahua",
      //   componentName: "COFE"
      // },
      {
        title: "Ley de Hacienda del Estado de Chihuahua",
        componentName: "LHACUU"
      },
      {
        title: "Código Fiscal del la Federación",
        componentName: "COFF"
      },
      {
        title: "Ley del Impuesto al Valor Agregado",
        componentName: "IVA"
      },
      {
        title: "Ley de Lavado de Dinero",
        componentName: "LAVADO"
      }
    ]
  })
};
</script>

<style>
</style>